import { PAGES_SERVICE } from "@/services/pages.service.js";

const state = {postPageOutput: false, getPagesOutput: {}, putPageOutput: false, deletePageByIdOutput: false, getPageBySlugOutput: {}};

const actions = {
    //Service to create pages
    postPage({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPageRequest');

        PAGES_SERVICE.postPage(input)
            .then(
                output => {
                    commit('postPageSuccess', output);
                },
                error => {
                    commit('postPageFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated pages
    getPages({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPagesRequest');

        PAGES_SERVICE.getPages(queryParams)
            .then(
                output => {
                    commit('getPagesSuccess', output);
                },
                error => {
                    commit('getPagesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update pages
    putPage({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putPageRequest');

        PAGES_SERVICE.putPage(input)
            .then(
                output => {
                    commit('putPageSuccess', output);
                },
                error => {
                    commit('putPageFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove pages
    deletePageById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deletePageByIdRequest');

        PAGES_SERVICE.deletePageById(id)
            .then(
                output => {
                    commit('deletePageByIdSuccess', output);
                },
                error => {
                    commit('deletePageByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get pages by slug
    getPageBySlug({ dispatch, commit }, slug) {
        dispatch('alert/clear', null, { root: true });
        commit('getPageBySlugRequest');

        PAGES_SERVICE.getPageBySlug(slug)
            .then(
                output => {
                    commit('getPageBySlugSuccess', output);
                },
                error => {
                    commit('getPageBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postPage
    postPageRequest(state) {
        state.postPageOutput = null;
    },
    postPageSuccess(state, output) {
        state.postPageOutput = true;
    },
    postPageFailure(state) {
        state.postPageOutput = false;
    },

    //getPages
    getPagesRequest(state) {
    },
    getPagesSuccess(state, output) {
        state.getPagesOutput = output;
    },
    getPagesFailure(state) {
        state.getPagesOutput = false;
    },

    //putPage
    putPageRequest(state) {
        state.putPageOutput = null;
    },
    putPageSuccess(state, output) {
        state.putPageOutput = true;
    },
    putPageFailure(state) {
        state.putPageOutput = false;
    },

    //deletePageById
    deletePageByIdRequest(state) {
        state.deletePageByIdOutput = null;
    },
    deletePageByIdSuccess(state, output) {
        state.deletePageByIdOutput = true;
    },
    deletePageByIdFailure(state) {
        state.deletePageByIdOutput = false;
    },

    //getPageBySlug
    getPageBySlugRequest(state) {
    },
    getPageBySlugSuccess(state, output) {
        state.getPageBySlugOutput = output;
    },
    getPageBySlugFailure(state) {
        state.getPageBySlugOutput = false;
    },
};

export const pages = {
    namespaced: true,
    state,
    actions,
    mutations
};